export const CHART_TYPES = {
  PIE: "pie",
  BAR: "bar",
  TABLE: "table",
  CHOROPLETH: "choropleth",
  LINE: "line",
} as const;

export type ChartType = (typeof CHART_TYPES)[keyof typeof CHART_TYPES];
